/** A confirmed deletion retries only an explicit pre-delete cleanup wait. */
export async function deleteCharacter(body, {
  request = (url, options) => fetch(url, options),
  wait = ms => new Promise(resolve => setTimeout(resolve, ms)),
  onPending = () => {}, isCurrent = () => true,
} = {}) {
  const payload = JSON.stringify(body);
  for (let attempt = 0; attempt < 4; attempt++) {
    if (!isCurrent()) throw new Error('화면이나 계정이 바뀌어 삭제 확인을 중단했다. 캐릭터 목록을 확인해 달라.');
    const response = await request('/api/char/delete', {
      method: 'POST', headers: { 'content-type': 'application/json' }, body: payload,
      signal: AbortSignal.timeout(10_000),
    });
    const decoded = await response.json().catch(() => null);
    const result = decoded && typeof decoded === 'object' ? decoded : {};
    if (response.ok) {
      if (result.ok === true) return;
      throw new Error('삭제 결과를 확인하지 못했다. 캐릭터 목록을 새로 고쳐 확인해 달라.');
    }
    if (response.status !== 409 || result.code !== 'character_delete_pending' || attempt === 3) {
      throw new Error(result.error || '캐릭터를 삭제하지 못했다. 잠시 뒤 다시 시도해 달라.');
    }
    onPending(result.error || '캐릭터의 저장과 정리를 확인하고 있다. 잠시 기다려 달라.');
    const delay = Number(result.retryAfterMs);
    await wait(Number.isFinite(delay) ? Math.max(250, Math.min(3000, delay)) : 1000);
  }
}
